<div class="floor-management">
  <div class="row justify-content-between mb-2 position-relative px-4">
    <app-search-field
      (searchCriteria)="searchUnitsEvent($event)"
      class="col-10"
      [placeholderText]="'SEARCH_FOR_FLOOR' | translate"
    ></app-search-field>

    <ng-container *ngIf="isUnitAndAccessPointLoaded && isListAvailable ; else elseFloorEmpty">
      <div class="col-2 text-right">
        <span class="position-relative">
          <img
            class="col-auto menu-icon pointer-cursor"
            src="assets/svg/ico-menu-circle.svg"
            (click)="onFilterUnit()"
          />
          <span class="mf-badge" *ngIf="filterCount !== 0">
            <span class="circle-content">
              {{ filterCount || "" }}
            </span>
          </span>
        </span>
      </div>
    </ng-container>

    <ng-template #elseFloorEmpty>
      <img
        class="col-auto menu-icon not-allowed"
        src="assets/svg/ico-menu-circle.svg"
      />
    </ng-template>
  </div>
  <div *ngIf="!isNestedCallActive && isListAvailable && floors?.length > 0">
    <div
      *ngFor="
        let floor of floors
          | sortBy : 'floorName' : 'asc'
          | filterBy : ['floorName'] : searchUnit;
        let i = index;
        trackBy: trackByOption
      "
    >
      <div class="position-relative floor-item">
        <app-floor-item
          [name]="floor.floorName"
          [wingName]="floor.wingName"
          [floorId]="floor.floorId"
        >
          <ng-container *ngIf="isUnitAndAccessPointFetch[i]" cornerElement>
            <app-spinner-loader id="floor.floorId"></app-spinner-loader>
          </ng-container>
        </app-floor-item>
      </div>

      <ng-container *ngFor="let item of floor?.unitList">
        <ng-container *ngIf="item.unitId">
          <app-floor-unit-item
            [name]="item.unitName"
            [unitStatus]="item.unitStatus"
            [unitId]="item.unitId"
            [floorId]="floor.floorId"
            [floorName]="floor.floorName"
            [isNonActive]="item.isNonActive"
            [isLatestFirmwareAvailable]="item.firmwareUpdateAvailable"
            [isLockBatteryLow]="item.isLockBatteryLow"
            [ngClass]="{ 'disabled-click': isDisabledClickUnitAndAccessPoint }"
          ></app-floor-unit-item>
        </ng-container>
        <ng-container *ngIf="item.accessPointId">
          <ng-container *appHideAccess="commonAccessControl">
            <app-floor-access-point
              [name]="item.accessPointName"
              [accessPointStatus]="item.accessPointStatus"
              [accessPointId]="item.accessPointId"
              [floorId]="floor.floorId"
              [floorName]="floor.floorName"
              [ngClass]="{
                'disabled-click': isDisabledClickUnitAndAccessPoint
              }"
            ></app-floor-access-point>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <ng-container
    *ngIf="!isNestedCallActive && isListAvailable && floors?.length === 0"
  >
    <div>
      <div
        class="d-flex flex-column justify-content-center align-items-center h-100"
      >
        <div
          class="text-container d-flex flex-column justify-content-center align-items-center"
        >
          <div class="icon-container">
            <img src="assets/svg/ico-default-home.svg" class="home-icon" />
          </div>
          <div class="text-center mt-3">
            <p>{{ 'NO_FLOORS_AVAILABLE_FOR_APPLIED_FILTER' | translate }}</p>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <div *ngIf="!isListAvailable && !isNestedCallActive">
    <div
      class="d-flex flex-column justify-content-center align-items-center h-100"
    >
      <div
        class="text-container d-flex flex-column justify-content-center align-items-center"
      >
        <div class="icon-container">
          <img src="assets/svg/ico-floor.svg" class="home-icon" />
        </div>
        <div class="text-center mt-3">
          <p>{{ 'NO_FLOORS_AVAILABLE' | translate }}</p>
        </div>
      </div>
    </div>
    <div></div>
  </div>

  <ng-container *ngIf="isNestedCallActive">
    <div class="centered h-100">
      <app-nested-loader></app-nested-loader>
    </div>
  </ng-container>
</div>
